import React, { Component } from "react";
import LuggageTooltip from "./LuggageTooltip";
import { connect } from "react-redux";

class DispatchLuggage extends Component {
	constructor() {
		super();
		this.state = { showTooltip: false };
	}

	setData() {
		let content = {
				icon: "",
				message: "",
				type: ""
			},
			{ isInternational, airline } = this.props;

		if (this.props.lugagge.checked.prices[0] === 0) {
			content.icon = "icon-handbag";
			content.message = isInternational
				? airline == "avianca"
					? "Bagagem despachada incluída comprando com a MaxMilhas"
					: "Bagagem despachada incluída"
				: airline == "avianca"
					? "Despacho gratuito de bagagem comprando com a MaxMilhas"
					: "Despacho gratuito de bagagem";
			content.type = "included";
		} else {
			let { weight } = this.props.lugagge.checked;

			content.icon = "icon-bad-on-board";
			content.message = `${
				(weight === null && !isInternational) || weight !== null ? "Apenas b" : "B"
			}agagem de mão incluída`;
			content.type = "not-included";
		}

		return content;
	}

	toogleTooltip() {
		let { showTooltip } = this.state;
		this.setState({ showTooltip: !showTooltip });
	}

	render() {
		if (this.props.lugagge) {
			let content = this.setData();
			const { icon, message, type } = content;

			return (
				<div className={`dispatch-luggage ${type}`}>
					<span data-action="dispatch-luggage-show-warning" onClick={() => this.toogleTooltip()}>
						<i className={`icon ${icon}`} onClick={() => this.toogleTooltip()} />
						{message}{" "}
						<i className="tooltip" data-flow="down" onClick={() => this.toogleTooltip()}>
							?
						</i>
					</span>

					<LuggageTooltip
						key={this.props.childId}
						childId={this.props.childId}
						content={{
							airline: this.props.airline,
							luggage: this.props.lugagge
						}}
						show={this.state.showTooltip}
						isInternational={this.props.isInternational}
					/>
				</div>
			);
		}

		return (
			<div className="dispatch-luggage no-luggage">
				<span>
					<i className="icon icon-attention" />
					Regras de bagagem indisponível
				</span>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	isInternational: state.searchStatus.isInternational
});

export default connect(mapStateToProps)(DispatchLuggage);
